import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { formatDistanceToNowStrict } from 'date-fns';
import { renderSolution, renderStatus } from '../../utils/tables';
import Pill from '../../components/pill';
import PillGroup from '../../components/pill/pillGroup';

const tableHeaders = [
  {
    Header: 'Site Name',
    id: 'displayName',
    type: 'string',
    accessor: site => renderName(site.displayName, 'displayName', site.id)
  },
  {
    Header: 'Assets attached',
    id: 'assets',
    type: 'string',
    disableSortBy: true,
    accessor: site => renderAssets(site.assets)
  },
  {
    Header: 'Site Status',
    id: 'status',
    type: 'string',
    accessor: site => (site.status ? renderStatusData(site.status) : '--')
  },
  {
    Header: 'Solution',
    id: 'solution',
    type: 'string',
    accessor: site => (site.solution ? renderSolution(site.solution, site.solution) : '--')
  },
  {
    Header: 'Site Type',
    id: 'type.displayName',
    type: 'string',
    accessor: site => site.type.displayName
    // disableSortBy: true
  },
  {
    Header: 'Created',
    id: 'createTime',
    type: 'string',
    accessor: site =>
      site.createTime ? (
        <div className="ellipsis">{formatDistanceToNowStrict(new Date(site.createTime))} ago</div>
      ) : (
        '--'
      )
  }
];

const renderName = (name, fieldName, key) => {
  return (
    <div className="ellipsis">
      <div id={`${fieldName}-${key}`}>{name}</div>
      <UncontrolledTooltip placement="top" target={`#${fieldName}-${key}`}>
        {name}
      </UncontrolledTooltip>
    </div>
  );
};

const renderStatusData = status => {
  if (status === 'NOT_CONFIGURED') {
    return renderStatus('not-configured');
  }

  return renderStatus(status);
};

const renderAssets = assets => {
  if (!assets || assets.length === 0) {
    return <span className="status badge badge-pill badge-outline-secondary">No Assets</span>;
  }

  if (assets.length === 1) {
    return <Pill itemKey={assets[0].id} text={assets[0].displayName || assets[0].id} tooltipText={assets[0].id} />;
  }

  const firstAsset = {
    itemKey: assets[0].id,
    text: assets[0].displayName || assets[0].id,
    tooltipText: assets[0].id
  };
  const assetsCounter = {
    itemKey: `assets-count-${assets.length}`,
    text: `+ ${assets.length - 1}`,
    tooltipText: `+ ${assets.length - 1} Assets attached`
  };
  return <PillGroup pills={[firstAsset, assetsCounter]} />;
};

export default tableHeaders;
